module.exports = __webpack_public_path__ + "static/media/PDF_1.3ff772e4.pdf";